var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "filters" }, [
    _c("div", { staticClass: "left" }, [_c("Reports-ReportTypeFilter")], 1),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }